import { useTranslation } from "react-i18next";

const News2 = () => {
    const { t } = useTranslation();

    return <p>{t("Dashboard##news##body##2")}</p>;
};

export { News2 };
